<template>
    <div class="dashboard-graphs-container">
        <ul class="nav nav-tabs">
            <li class="nav-item" :class="(selectedGraph == 0) ? 'active' : undefined">
                <a class="nav-link" @click="showGraph(0)" href="#">Market Change</a>
            </li>
        </ul>
        <span class="dropdown float-right">
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="timePeriodFXDropdown">
                <div class="dropdown-item" 
                    v-for="(timePeriodOption, key) in timePeriodList" :key="key" @click="selectTimePeriod(timePeriodOption)">
                    <span>
                        {{ timePeriodOption | timeperiodgraphs }}
                    </span>
                </div>
            </div>
        </span>
        <div class="w-100 card pt-2 px-2 border-radius-top-left-0">
            <market-change-graph />
        </div>
    </div>    
</template>

<script>

import MarketChangeGraph from './MarketChangeGraph.vue'
import { mapActions } from "vuex";

export default {
    components: {
        MarketChangeGraph
    },
    data:function(){
        return {
            selectedGraph: 0,
            timePeriodList: [0, 1, 2, 3],
            selectedTimePeriod:0
        }
    },
    created() {
        this.selectGraphsTimePeriod(this.selectedTimePeriod)
    },
    methods: {
        ...mapActions('graphs', ['selectGraphsTimePeriod']),
        showGraph: function(graphIndex) {
            event.preventDefault()
            this.selectedGraph = graphIndex
        },
        selectTimePeriod: function (timePeriod){
            this.selectedTimePeriod=timePeriod
            this.selectGraphsTimePeriod(timePeriod)
        }
    }
}
</script>

<style lang="scss" scoped>
.dropdown {
    top: -30px;
}

.dropdown-item{
    cursor:pointer;

    &:active {
        background-color: map-get($theme-colors, primary);
    }
}

.dropdown-toggle {
    color: map-get($theme-colors, olf-black)!important;
    text-decoration: none;
}
</style>
